import { Base64 } from "js-base64";

// Parse passed data from server
if (window.DATA && window.DATA !== "{{data}}") {
  window.DATA = JSON.parse(Base64.decode(window.DATA));
} else {
  window.DATA = {};
}
